import React from 'react';

import { styled } from '@gogame/components';

const LineLabel = styled(
  React.forwardRef(({ dashed: _, ...props }, ref) => (
    <span {...props} ref={ref} />
  ))
)`
  height: 0px;
  border: 0;
  border-color: ${(props) => props.theme.palette.action.disabled};
  border-top-width: 2px;
  border-style: ${(props) => (props.dashed ? 'dashed' : 'solid')};
  width: 14px;
  display: flex;
`;

export default LineLabel;
